// extracted by css-extract-rspack-plugin
module.exports =  {"root":"PageTip__root___FHuYu","box":"PageTip__box___i1wEj"};